import { NgModule } from "@angular/core";
import { ToastModule } from 'primeng/toast';
import { TableModule } from 'primeng/table';
import { SliderModule } from 'primeng/slider';
import { DialogModule } from 'primeng/dialog';
import { MultiSelectModule } from 'primeng/multiselect';
import { ContextMenuModule } from 'primeng/contextmenu';


import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { ProgressBarModule } from 'primeng/progressbar';
import { RippleModule } from 'primeng/ripple';
import { CheckboxModule } from 'primeng/checkbox';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CalendarModule } from 'primeng/calendar';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { RatingModule } from 'primeng/rating';
import { TooltipModule } from 'primeng/tooltip';
import { TreeTableModule } from 'primeng/treetable';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ChartModule } from 'primeng/chart';
import { PaginatorModule } from 'primeng/paginator';
import { InputNumberModule } from "primeng/inputnumber";
import { BadgeModule } from 'primeng/badge';
import { TabViewModule } from 'primeng/tabview';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { DragDropModule } from 'primeng/dragdrop';
import { AccordionModule } from 'primeng/accordion';
import { KnobModule } from 'primeng/knob';
import { SelectButtonModule } from 'primeng/selectbutton';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { CardModule } from 'primeng/card';
import { FieldsetModule } from 'primeng/fieldset';
import { PanelModule } from 'primeng/panel';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ListboxModule } from 'primeng/listbox';
import { SplitterModule } from 'primeng/splitter';
import { TreeSelectModule } from 'primeng/treeselect';
import { TabMenuModule } from 'primeng/tabmenu';

const ngPrimeModules: any = [
    ToastModule
    , TableModule
    , ButtonModule
    , InputTextModule
    , ProgressBarModule
    , DialogModule
    , DropdownModule
    , RippleModule
    , CheckboxModule
    , ContextMenuModule
    , MultiSelectModule
    , SliderModule
    , RadioButtonModule
    , CalendarModule
    , OverlayPanelModule
    , ConfirmDialogModule
    , RatingModule
    , TooltipModule
    , TreeTableModule
    , InputSwitchModule
    , ChartModule
    , PaginatorModule
    , InputNumberModule
    , BadgeModule
    , TabViewModule
    , ProgressSpinnerModule
    , BreadcrumbModule
    , MessagesModule
    , MessageModule,
    DragDropModule,
    AccordionModule,
    KnobModule,
    SelectButtonModule,
    DynamicDialogModule,
    ScrollPanelModule,
    CardModule,
    FieldsetModule,
    PanelModule,
    ToggleButtonModule,
    TreeSelectModule,
    ListboxModule,
    TabMenuModule,
];

@NgModule({
    imports: [ngPrimeModules],
    exports: [ngPrimeModules]
})
export class CommonPrimeNgModule { }